import { createRoutine, promisifyRoutine} from 'redux-saga-routines';

export const getCorrespondantRoutine = createRoutine('GET_CORRESPONDANT');
export const getCorrespondantsRoutine = createRoutine('GET_CORRESPONDANTS'); 

export const postCorrespondantRoutine = createRoutine('POST_CORRESPONDANT'); 
export const postCorrespondantRoutinePromiseCreator = promisifyRoutine(postCorrespondantRoutine);

export const putCorrespondantRoutine = createRoutine('PUT_CORRESPONDANT');
export const putCorrespondantRoutinePromiseCreator = promisifyRoutine(putCorrespondantRoutine);

export const deleteCorrespondantRoutine = createRoutine('DELETE_CORRESPONDANT');
export const deleteCorrespondantRoutinePromiseCreator = promisifyRoutine(deleteCorrespondantRoutine);


